module.exports = __webpack_public_path__ + "img/yingshiwang_w.44f89e32.png";